import React from 'react';
import Link from 'gatsby-link';
import Helmet from 'react-helmet';
import styles from './styles.module.css';

import TEXT from '../../../data/text.json';

import SearchCTA from '../../components/search-cta';
import BackgroundImage from '../../components/background-image';

import SiteFooter from '../../components/site-footer';
import GridContainer from '../../components/grid-container';
import GridRow from '../../components/grid-row';
import GridCol from '../../components/grid-col';
import GridWrap from '../../components/grid-wrap';
import TileLink from '../../components/tile-link';
import SubHeading from '../../components/sub-heading';
import BackgroundContainer from '../../components/background-container';
import ItemLink from '../../components/item-link';
import PillButton from '../../components/pill-button';

import RoomImage from '../../images/room.jpg';
import TileOneImage from '../../images/tile-one.jpg';
import TileTwoImage from '../../images/tile-two.jpg';

const IndexPage = () => (
  <div>
    <Helmet title="Home" />
    <BackgroundContainer src={RoomImage}>
      <div className={styles.search}>
        <h1>{TEXT.PAGES.HOMEPAGE.title}</h1>
        <p>{TEXT.PAGES.HOMEPAGE.subtitle}</p>
        <SearchCTA />
      </div>
    </BackgroundContainer>

    <div className={styles.lowerSection}>
      <GridContainer>
        <GridRow>
          <GridCol>
            <div className={styles.itemPreview}>
              <SubHeading text={TEXT.PAGES.HOMEPAGE.itemsTitle} />
              <p>{TEXT.PAGES.HOMEPAGE.itemsSubtitle}</p>
              <PillButton
                small
                tag={Link}
                text={TEXT.PAGES.HOMEPAGE.itemsSeeAllLinkText}
                to={TEXT.PAGES.HOMEPAGE.itemsSeeAllLinkTarget}
              />
              <ul>
                {TEXT.PAGES.HOMEPAGE.itemsIds.split(',').map(id => (
                  <li key={id}>
                    <ItemLink
                      id={id}
                      imageSizes="(min-width: 1200px) 244px, (min-width: 1024px) calc(25vw - 2.75rem), (min-width: 768px) calc(50vw - 5rem), calc(100vw - 4rem)"
                    />
                  </li>
                ))}
              </ul>
            </div>
          </GridCol>
          <GridCol>
            <SubHeading text={TEXT.PAGES.HOMEPAGE.moreTitle} />
          </GridCol>
          <GridCol>
            <div className={styles.links}>
              <div className={styles.link}>
                <TileLink
                  imageSrc={TileOneImage}
                  to={TEXT.PAGES.HOMEPAGE.historyLinkTarget}
                  title={TEXT.PAGES.HOMEPAGE.historyLinkTitle}
                  text={TEXT.PAGES.HOMEPAGE.historyLinkText}
                />
              </div>
              <div className={styles.link}>
                <TileLink
                  imageSrc={TileTwoImage}
                  to={TEXT.PAGES.HOMEPAGE.contributeLinkTarget}
                  title={TEXT.PAGES.HOMEPAGE.contributeLinkTitle}
                  text={TEXT.PAGES.HOMEPAGE.contributeLinkText}
                />
              </div>
            </div>
          </GridCol>
        </GridRow>
      </GridContainer>
    </div>
    <SiteFooter />
  </div>
);

export default IndexPage;



// WEBPACK FOOTER //
// ./src/page-components/homepage/index.js